/**
 * DS Compare — Hide the "Awaiting selection" placeholder
 * ---------------------------------------------------------------
 * The section shows this placeholder on mobile until a competitor is loaded,
 * and only hides it from inside its own closure. It should disappear the
 * moment a lookup STARTS — not linger through a 10-second wait — and stay
 * gone once a product is loaded.
 */
(function () {
  function awaitingEl() {
    return document.getElementById('dscmp-awaiting');
  }

  function hideAwaiting() {
    var el = awaitingEl();
    if (!el) return;
    el.classList.remove('is-visible');
    el.hidden = true;
  }

  function showAwaiting() {
    var el = awaitingEl();
    if (!el) return;
    var card = document.getElementById('dscmp-vscard');
    // Only restore it if nothing is loaded.
    if (card && !card.classList.contains('is-empty')) return;
    el.hidden = false;
    if (window.matchMedia('(max-width:767px)').matches) el.classList.add('is-visible');
  }

  /* Any of these actions means a product is on its way — drop the placeholder. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#dscmp-urlgo') || t.closest('#dscmp-upload')) {
      hideAwaiting();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.id === 'dscmp-file') hideAwaiting();
    if (t.id === 'dscmp-select') {
      if (t.value === '') showAwaiting();
      else hideAwaiting();
    }
  }, true);

  document.addEventListener('paste', function () {
    var modal = document.getElementById('dscmp-modal');
    if (modal && !modal.hidden) hideAwaiting();
  }, true);

  document.addEventListener('drop', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('#dscmp-upload')) hideAwaiting();
  }, true);

  /* Keep it hidden whenever a competitor card is populated. */
  function watchCard() {
    var card = document.getElementById('dscmp-vscard');
    if (!card || card.dataset.dscmpAwait === '1') return;
    card.dataset.dscmpAwait = '1';
    new MutationObserver(function () {
      if (!card.classList.contains('is-empty')) hideAwaiting();
    }).observe(card, { attributes: true, attributeFilter: ['class'] });
  }

  var mo = new MutationObserver(watchCard);

  function start() {
    watchCard();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
